var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 30C0.666626 13.7996 13.7996 0.666626 30 0.666626C46.2003 0.666626 59.3333 13.7996 59.3333 30C59.3333 46.2003 46.2003 59.3333 30 59.3333C13.7996 59.3333 0.666626 46.2003 0.666626 30ZM30 5.99996C16.7451 5.99996 5.99996 16.7451 5.99996 30C5.99996 43.2548 16.7451 54 30 54C43.2548 54 54 43.2548 54 30C54 16.7451 43.2548 5.99996 30 5.99996Z",
    fill: "#0357FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8856 20.1143C44.927 21.1557 44.927 22.8441 43.8856 23.8855L27.8856 39.8855C26.8442 40.9269 25.1558 40.9269 24.1144 39.8855L16.1144 31.8855C15.073 30.8441 15.073 29.1557 16.1144 28.1143C17.1558 27.0729 18.8442 27.0729 19.8856 28.1143L26 34.2287L40.1144 20.1143C41.1558 19.0729 42.8442 19.0729 43.8856 20.1143Z",
    fill: "#0357FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.3a4088f6.svg";
export { ForwardRef as ReactComponent };